import styled from 'styled-components';

export const Title = styled.h1`
  font-size: 4rem;
  font-weight: 900;
  line-height: 46px;
  color: ${({ theme }) => theme.color.mobilityGrey};
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: 3.2rem;
  }
`;

export const ImageWrapper1 = styled.div`
  height: min(70rem, 85vh);
  border-top-right-radius: 6rem;
  overflow: hidden;
  position: relative;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    border-bottom-right-radius: 0;
  }
`;

export const ImageWrapper2 = styled.div`
  height: min(70rem, 85vh);
  border-bottom-right-radius: 6rem;
  overflow: hidden;
  position: relative;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    border-bottom-right-radius: 0;
  }
`;

export const TextWrapper = styled.div`
  padding: 6rem 6rem 0 0;
  margin-left: 13.5rem;
  width: min(100%, 60rem);
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1280}) {
    margin: auto;
    margin-left: 7rem;
    width: min(100%, 55rem);
  }
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    padding: 0;
    width: min(100%, 50rem);
  }
`;

export const List = styled.ol`
  list-style: none;
  counter-reset: list-counter;
  padding-left: 0;
`;

export const ListItem = styled.li`
  display: flex;
  align-items: flex-start;
  counter-increment: list-counter;

  color: ${({ theme }) => theme.color.mobilityGrey};
  font-size: ${({ theme }) => theme.fontSize.size22};
  font-weight: ${({ theme }) => theme.fontWeight.weight400};
  line-height: ${({ theme }) => theme.lineHeight.height140};

  padding: 1.5rem 0rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size18};
  }
`;

export const Index = styled.span`
  min-width: 3rem;

  &::before {
    content: counter(list-counter) '.';
    display: block;
  }
`;

export const Content = styled.span`
  flex: 1;
`;

export const ButtonWrapper = styled.div`
  background-color: ${({ theme }) => theme.color.white};
  padding: 4rem 2rem;
`;
